export default __webpack_public_path__ + "static/media/freemium.65b16a91.svg";